import { render, staticRenderFns } from "./UpcomingDepartures.vue?vue&type=template&id=7c305378&scoped=true&"
import script from "./UpcomingDepartures.vue?vue&type=script&lang=js&"
export * from "./UpcomingDepartures.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingDepartures.vue?vue&type=style&index=0&id=7c305378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c305378",
  null
  
)

export default component.exports